module.exports = __webpack_public_path__ + "img/image-04.a2fbe699.webp";